import './App.css'
import {Box} from '@chakra-ui/react'
import {NavBar} from './components/NavBar/NavBar'
import AppRouter from './components/AppRouter/AppRouter'
import { CompaniesProvider } from 'stores/CompaiesContext'

function App() {
    return (
        <div className='App'>
            <CompaniesProvider>
                <NavBar position='sticky' top={0} bg='white' zIndex='sticky' />
                <Box as='main' position='absolute' height='90vh' overflowY='auto' overflowX='hidden'
                    p={4}
                    w='full'
                    //  maxW='1900px'
                    mx='auto'
                >
                    <AppRouter/>
                </Box>
            </CompaniesProvider>

        </div>
    )
}

export default App
